import styled from 'styled-components';
import { media } from '../../../styles/style-utils';

export const TextBlockItem = styled.div`
  flex: 1;

  h2 {
    font-size: ${props => props.content.headlineFontSize || 'var(--fs-m)'};
    margin-bottom: 2rem;
  }
`;

export const HeroItem = styled.div`
  flex: 1;
`;

export const CardItem = styled.div`
  width: calc(100vw - 4 * var(--fr)) !important;
  background: var(--c-black);
  flex: 1;

  ${media.small`
    width: calc(18 * var(--fr)) !important;
  `}

  ${media.mediumLarge`
    width: calc(22.5 * var(--fr)) !important;
  `};

  div {
    margin-bottom: calc(1.5 * var(--fr));
  }

  img {
    margin-bottom: 0;
  }

  h2,
  div > div {
    margin: 0 calc(1.5 * var(--fr));
    margin-top: calc(1.5 * var(--fr));
  }
`;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/utils/CustomItem.js